// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e6f357a1","126":"e1619f02","196":"9d7b41be","207":"5156e7af","227":"a14b6c4e","256":"6e715915","599":"369928f9","615":"f42415a4"}[chunkId] + ".chunk.js";
};